module.exports = __webpack_public_path__ + "img/sheenhaironblack.b878c03d.png";